import { useState, useEffect } from 'react';
import RazorpayPayment from './RazorpayPayment';
import { FaCheck, FaStar, FaExclamationCircle } from 'react-icons/fa';
import './Pricing.css';
import { toast } from 'react-toastify';

const Pricing = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [location, setLocation] = useState(null);
  const [country, setCountry] = useState('');
  const [step, setStep] = useState(1);
  const [fullName, setFullName] = useState('');
  const [address, setAddress] = useState('');
  const [exchangeRate, setExchangeRate] = useState(85.55);
  const [formErrors, setFormErrors] = useState({});
  const [gstin, setGstin] = useState('');
  const [showGstinModal, setShowGstinModal] = useState(false);
  const [selectedFruit, setSelectedFruit] = useState('');
  const [showTaxBreakup, setShowTaxBreakup] = useState(false);
  const [taxType, setTaxType] = useState('');
  const [taxQuestions, setTaxQuestions] = useState({
    q1: false,
    q2: false,
    q3: false,
    q4: false
  });
  const [additionalPrice, setAdditionalPrice] = useState(0);
  const [hours, setHours] = useState(1);
  const [companyType, setCompanyType] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [hasSSN, setHasSSN] = useState(null);
  const [registeredAgent, setRegisteredAgent] = useState(true);
  const [quickPaymentCard, setQuickPaymentCard] = useState(null);
  const [promoCode, setPromoCode] = useState('');
  const [promoCodeDetails, setPromoCodeDetails] = useState(null);
  const [promoCodeError, setPromoCodeError] = useState('');
  const [promoCodeLoading, setPromoCodeLoading] = useState(false);

  // Slider related states
  const [sliderValue, setSliderValue] = useState(1);
  const maxDots = 6;
  const baseBookkeepingPrice = 100;
  const baseCFOPrice = 200;
  const priceIncrement = 60;
  const monthlyExpenseRange = 20000 + (sliderValue - 1) * 15000;

  // const fruits = ['Apple', 'Banana', 'Mango', 'Orange', 'Grapes'];

  const fruits = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand',
    'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur',
    'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab',
    'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura',
    'Uttar Pradesh', 'Uttarakhand', 'West Bengal'
  ];

  const allCountries = [
    "United States", "United Kingdom", "Austria", "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola",
    "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Azerbaijan", "Bahamas",
    "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan",
    "Bolivia, Plurinational State of", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana",
    "Bouvet Island", "Brazil", "British Indian Ocean Territory", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi",
    "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China",
    "Christmas Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo", "Congo, the Democratic Republic of the",
    "Cook Islands", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti",
    "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini",
    "Ethiopia", "Falkland Islands (Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia",
    "French Southern Territories", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada",
    "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands",
    "Holy See", "Honduras", "Hong Kong", "Hungary", "Iceland", "Indonesia", "Iran, Islamic Republic of",
    "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya",
    "Kiribati", "Korea, Democratic People's Republic of", "Korea, Republic of", "Kuwait", "Kyrgyzstan",
    "Lao People's Democratic Republic", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
    "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Martinique",
    "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Moldova, Republic of", "Monaco",
    "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
    "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "North Macedonia",
    "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea",
    "Paraguay", "Peru", "Philippines", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Réunion", "Romania",
    "Russian Federation", "Rwanda", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis",
    "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa",
    "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore",
    "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa",
    "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname",
    "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan, Province of China", "Tajikistan",
    "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago",
    "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "Uruguay", "Uzbekistan",
    "Vanuatu", "Venezuela, Bolivarian Republic of", "Viet Nam", "Western Sahara", "Yemen", "Zambia", "Zimbabwe"
  ];

  const companyTypes = ['LLC', 'C-corporation'];
  const usStates = ['Wyoming', 'Delaware', 'New Jersey', 'Texas'];

  const stateFees = {
    LLC: {
      Wyoming: 104,
      Delaware: 110,
      'New Jersey': 130,
      Texas: 310
    },
    'C-corporation': {
      Wyoming: 104,
      Delaware: 109,
      'New Jersey': 130,
      Texas: 310
    }
  };

  const services = [
    {
      _id: 'service_1',
      name: 'USA Company Formation',
      price: 300,
      popular: true,
      frequency: 'one time',
      details: [
        'Formation Document',
        'Registered Agent Services (1 year)',
        'EIN and ITIN (Individual Tax Identification Number)',
        'Foreign Qualification',
      ],
      hasCompanySelection: true
    },
    {
      _id: 'service_2',
      name: 'Tax and Form Return (Starting)',
      price: 150,
      popular: false,
      frequency: 'per year',
      details: [
        'Individual Tax Return (Form 1040 and 1040NR)',
        'Business Tax Return (Form 1065, 1120 and 1120S)',
        'USA State Annual Report Filing',
      ],
      hasQuestions: true
    },
    {
      _id: 'service_3',
      name: 'Pay-As-You-Go',
      price: 8,
      popular: false,
      frequency: 'per hour',
      details: [
        'Dedicated Accountant',
        'Financial Reports',
        'Cash Basis or Accrual Basis',
        'Bank and Credit Card Reconciliation',
        'Books Clean-up'
      ],
      hasHoursSelection: true
    },
    {
      _id: 'service_4',
      name: 'Bookkeeping',
      price: baseBookkeepingPrice + (sliderValue - 1) * priceIncrement,
      popular: false,
      frequency: 'per month',
      details: [
        'Dedicated Accountant',
        'Monthly or Weekly Accounting',
        'Cash Basis or Accrual Basis',
        'Monthly Financial Reports',
      ]
    },
    {
      _id: 'service_5',
      name: 'CFO Advisory',
      price: baseCFOPrice + (sliderValue - 1) * priceIncrement,
      popular: false,
      frequency: 'per month',
      details: [
        'Dedicated CFO Analyst',
        'Monthly and Quarterly CFO Meeting',
        'Forecasting and Budgeting',
        'Monthly Financial Reports',
      ]
    },
    {
      _id: 'service_6',
      name: quickPaymentCard ? quickPaymentCard.name : 'Quick Payment',
      price: quickPaymentCard ? quickPaymentCard.price : 500,
      popular: false,
      frequency: 'one time',
      details: quickPaymentCard ? quickPaymentCard.details : [
        'Express Processing',
        '24-Hour Turnaround',
        'Priority Support',
        'Digital Documentation',
        'Secure Payment Gateway'
      ]
    },
    {
      _id: 'service_7',
      name: 'Registered Agent',
      price: 200,
      popular: false,
      frequency: 'per year',
      details: [
        'Annual Registered Agent Service',
        'Mail forwarding and handling',
        'Compliance notifications',
        'Document management',
        'Legal address maintenance'
      ]
    },
    {
      _id: 'service_8',
      name: 'Annual Report Service',
      price: 700,
      popular: false,
      frequency: 'per year',
      details: [
        'Annual Report Preparation',
        'State Compliance Filing',
        'Document Review',
        'Filing Confirmation',
        'Email Notifications'
      ]
    },
    {
      _id: 'service_9',
      name: 'Tax + Bookkeeping Bundle',
      price: 950,
      popular: true,
      frequency: 'per Year',
      details: [
        'Individual Tax Return',
        'Business Tax Return',
        'Dedicated Accountant',
      ]
    },
  ];

  const taxTypeDetails = {
    business: {
      title: 'Business Tax Return Filing (Forms 1120, 1120S, 1065)',
      questions: [
        {
          id: 'q1',
          text: 'Do you have a prepared P&L and Balance Sheet?',
          price: 75
        },
        {
          id: 'q2',
          text: 'Do you have depreciable assets to report? (Upto 5 depreciable Asset) ',
          price: 75
        },
        {
          id: 'q3',
          text: 'Are there foreign owners / foreign affiliates / controlled foreign corps requiring Form 5471 / 5472 / 8865 each? ',
          price: 50
        },
      ]
    },
    personal: {
      title: 'Personal Tax Return Filing (Form 1040)',
      questions: [
        {
          id: 'q1',
          text: 'Do you have foreign income to report? (Form 1116, Foreign Earned Income Exclusion)',
          price: 30
        },
        {
          id: 'q2',
          text: 'Do you have foreign Accounts to report? (FBAR & Form 8938) (upto 5 bank Account) ',
          price: 60
        },
        {
          id: 'q3',
          text: 'Do you need to file one more additional state tax return? ',
          price: 50
        },
        {
          id: 'q4',
          text: 'Do you have investment income to report? (upto 5 entries)',
          price: 30
        },
         {
          id: 'q5',
          text: 'Do you have rental income to report? (For One property)',
          price: 15
        },
         {
          id: 'q6',
          text: 'Do you have self-employment income? (Schedule C) ',
          price: 50
        },
         {
          id: 'q7',
          text: 'Do you need to claim tax credits? (EITC, Child Tax Credit, Education Credit each)',
          price: 15
        }
      ]
    }
  };

  useEffect(() => {
    setSelectedService(services[0]);

    const fetchExchangeRate = async () => {
      try {
        const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
        const data = await response.json();
        setExchangeRate(data.rates.INR);
      } catch (error) {
        console.error('Failed to fetch exchange rate, using default:', error);
      }
    };

    fetchExchangeRate();

    const fetchUser = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.ok) {
          const data = await response.json();
          setUser(data.user);
          
          // Fetch quick payment details after getting user info
          if (data.user && data.user._id) {
            fetchQuickPaymentDetails(data.user._id);
          } else {
            fetchQuickPaymentDetails();
          }
        }
      } catch (error) {
        console.error('Error fetching user:', error);
        // Still try to fetch global payment details if user fetch fails
        fetchQuickPaymentDetails();
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  const fetchQuickPaymentDetails = async (userId = null) => {
    try {
      // Add userId as query parameter if available
      const endpoint = `${process.env.REACT_APP_API_BASE_URL}/api/payment/quick-payment-details${userId ? `?userId=${userId}` : ''}`;
      const response = await fetch(endpoint);
      
      if (response.ok) {
        const data = await response.json();
        setQuickPaymentCard(data);
        
        // Update the services array with the fetched quick payment data
        if (data && services.length >= 6) {
          const updatedServices = [...services];
          updatedServices[5] = {
            ...updatedServices[5],
            name: data.name,
            price: data.price,
            details: data.details
          };
          // Update services directly
          services[5] = updatedServices[5];
        }
      }
    } catch (error) {
      console.error('Error fetching quick payment details:', error);
    }
  };

  useEffect(() => {
    // Calculate additional price based on answered questions
    if (taxType) {
      let total = 0;
      Object.entries(taxQuestions).forEach(([key, value]) => {
        if (value) {
          const question = taxTypeDetails[taxType].questions.find(q => q.id === key);
          if (question) {
            total += question.price;
          }
        }
      });
      setAdditionalPrice(total);
    }
  }, [taxQuestions, taxType]);

  const handleSliderChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    setSliderValue(newValue);
  };

  const handleDotClick = (dotIndex) => {
    setSliderValue(dotIndex + 1);
  };

  const handleBuyNow = (e, service) => {
    e.stopPropagation();
    setSelectedService(service);

    if (service._id === 'service_1' && service.hasCompanySelection) {
      setStep(1.1); // Special step for company formation
    } else if (service._id === 'service_2' && service.hasQuestions) {
      setStep(1.5); // Special step for tax service
    } else if (service._id === 'service_3' && service.hasHoursSelection) {
      setStep(1.25); // Special step for Pay-As-You-Go service
    } else if (service._id === 'service_8') {
      // Direct to payment for Annual Report Service
      setStep(2);
    } else {
      setStep(2); // Normal flow for other services
    }
  };

  const handleLocationSelect = (selectedLocation) => {
    setLocation(selectedLocation);
    setCountry('');
    if (selectedLocation === 'india') {
      setSelectedFruit('');
    } else {
      setSelectedFruit('');
      setStep(3);
    }
  };

  const handleProceedWithFruit = () => {
    if (location === 'india' && !selectedFruit) {
      alert('Please select a state');
      return;
    }
    setStep(3);
  };

  const handleTaxQuestionChange = (questionId, value) => {
    setTaxQuestions(prev => ({
      ...prev,
      [questionId]: value
    }));
  };

  const handleTaxTypeSelect = (type) => {
    setTaxType(type);
    // Reset questions when type changes
    setTaxQuestions({
      q1: false,
      q2: false,
      q3: false,
      q4: false
    });
  };

  const handleHoursChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (value >= 1 && value <= 100) {
      setHours(value);
    }
  };

  const handleCompanyTypeSelect = (type) => {
    setCompanyType(type);
    setSelectedState('');
    setHasSSN(null);
  };

  const handleStateSelect = (state) => {
    setSelectedState(state);
  };

  const handleSSNSelect = (hasSSN) => {
    setHasSSN(hasSSN);
  };

  const handleRegisteredAgentChange = (e) => {
    setRegisteredAgent(e.target.checked);
  };

  const validatePromoCode = async () => {
    if (!promoCode.trim()) {
      setPromoCodeError('Please enter a promo code');
      return;
    }

    if (!selectedService) {
      setPromoCodeError('Please select a service first');
      return;
    }

    setPromoCodeLoading(true);
    setPromoCodeError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/promo-codes/validate`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: promoCode.trim(),
          serviceName: selectedService.name
        })
      });

      const data = await response.json();

      if (data.success) {
        setPromoCodeDetails(data.promoCode);
        setPromoCodeError('');
      } else {
        setPromoCodeDetails(null);
        setPromoCodeError(data.message || 'Invalid promo code');
      }
    } catch (error) {
      console.error('Error validating promo code:', error);
      setPromoCodeError('Failed to validate promo code. Please try again.');
      setPromoCodeDetails(null);
    } finally {
      setPromoCodeLoading(false);
    }
  };

  const clearPromoCode = () => {
    setPromoCode('');
    setPromoCodeDetails(null);
    setPromoCodeError('');
  };

  const getStepClass = (stepNumber) => {
    if (stepNumber === 1.1) {
      return step >= 1.1 ? 'active-step' : '';
    }
    if (stepNumber === 1.25) {
      return step >= 1.25 ? 'active-step' : '';
    }
    if (stepNumber === 1.5) {
      return step >= 2 ? 'active-step' : (step === 1.5 ? 'active-step' : '');
    }
    return step >= stepNumber ? 'active-step' : '';
  };

  const getConvertedPrice = () => {
    if (!selectedService) return { basePrice: 0, gst: 0, total: 0, discount: 0 };

    let price = selectedService.price;
    let discount = 0;

    // Calculate price based on service type
    if (selectedService._id === 'service_1' && step >= 1.1) {
      // Base formation fee
      price = 300; // Our fee is fixed at $300

      // Apply promo code discount to Our Fee if valid
      if (promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee') {
        discount = 300 * (promoCodeDetails.discountPercentage / 100);
        price = 300 - discount;
      }

      // Add state fee
      if (selectedState) {
        price += stateFees[companyType][selectedState];
      }

      // Add EIN fee based on SSN
      if (hasSSN === true) {
        price += 55;
      } else if (hasSSN === false) {
        price += 210;
      }

      // Add registered agent fee if not free (first year is free with incorporation)
      if (!registeredAgent) {
        price += 125;
      }
    } else if (selectedService._id === 'service_2' && step >= 1.5) {
      price += additionalPrice;
    } else if (selectedService._id === 'service_3' && step >= 1.25) {
      price = price * hours;
    }

    if (location === 'india') {
      const basePrice = price * exchangeRate;
      const gst = basePrice * 0.18;
      const total = basePrice + gst;
      return {
        basePrice: basePrice.toFixed(2),
        gst: gst.toFixed(2),
        total: total.toFixed(2),
        discount: discount.toFixed(2)
      };
    }

    return {
      basePrice: price.toFixed(2),
      gst: 0,
      total: price.toFixed(2),
      discount: discount.toFixed(2)
    };
  };

  const validateGSTIN = (gstin) => {
    if (!gstin) return true;
    const regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    return regex.test(gstin);
  };

  const isServicePurchased = (serviceId) => {
    if (!user) return false;

    switch (serviceId) {
      case 'service_1':
        return user.isUSAEnabled;
      case 'service_2':
        return user.isTaxFilingEnabled;
      case 'service_4':
        return user.isBookkeepingEnabled;
      case 'service_5':
        return user.isCFOEnabled;
      case 'service_6':
        return user.isQuickEnabled;
      case 'service_7':
        return user.isRegisteredAgentEnabled;
      case 'service_8':
        return user.isAnnualReportServiceEnabled;
      default:
        return false;
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading services...</p>
      </div>
    );
  }

  return (
    <div className="pricing-page">
      {showGstinModal && (
        <div className="gstin-modal">
          <div className="gstin-modal-content">
            <h3>Add GSTIN Number</h3>
            <p>Enter your 15-digit GSTIN for invoice purposes (optional)</p>
            <input
              type="text"
              placeholder=""
              value={gstin}
              onChange={(e) => setGstin(e.target.value.toUpperCase())}
              maxLength="15"
            />
            {gstin && !validateGSTIN(gstin) && (
              <p className="gstin-error">Please enter a valid GSTIN number</p>
            )}
            <div className="gstin-modal-buttons">
              <button onClick={() => setShowGstinModal(false)}>Cancel</button>
              <button
                onClick={() => {
                  if (!gstin || validateGSTIN(gstin)) {
                    setShowGstinModal(false);
                  }
                }}
                className="primary"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="pricing-header-container">
        <div className="pricing-header">
          {step === 1 && (
            <>
              <h1>Choose Your Service</h1>
              <p>Select the accounting service that fits your needs</p>
            </>
          )}
          {step === 1.1 && <h1>USA Company Formation Details</h1>}
          {step === 1.25 && <h1>Select Hours for Pay-As-You-Go</h1>}
          {step === 1.5 && <h1>Tax Filing Details</h1>}
          {step === 2 && <h1>Select Your Location (Payment Currency)</h1>}
          {step === 3 && <h1>Order Summary</h1>}
        </div>

        <div className="pricing-tracker">
          <div className={`tracker-step ${getStepClass(1)}`}>
            <div className="step-number">1</div>
            <div className="step-label">Select Plan</div>
          </div>
          {selectedService?._id === 'service_1' && (
            <div className={`tracker-step ${getStepClass(1.1)}`}>
              <div className="step-number">1.1</div>
              <div className="step-label">Company </div>
            </div>
          )}
          {selectedService?._id === 'service_3' && (
            <div className={`tracker-step ${getStepClass(1.25)}`}>
              <div className="step-number">1.25</div>
              <div className="step-label">Select Hours</div>
            </div>
          )}
          {selectedService?._id === 'service_2' && (
            <div className={`tracker-step ${getStepClass(1.5)}`}>
              <div className="step-number">1.5</div>
              <div className="step-label">Tax Details</div>
            </div>
          )}
          <div className={`tracker-step ${getStepClass(2)}`}>
            <div className="step-number">
              {selectedService?._id === 'service_1' ? '2' :
                selectedService?._id === 'service_2' ? '2' :
                  selectedService?._id === 'service_3' ? '2' : '2'}
            </div>
            <div className="step-label">Location</div>
          </div>
          <div className={`tracker-step ${getStepClass(3)}`}>
            <div className="step-number">
              {selectedService?._id === 'service_1' ? '3' :
                selectedService?._id === 'service_2' ? '3' :
                  selectedService?._id === 'service_3' ? '3' : '3'}
            </div>
            <div className="step-label">Checkout</div>
          </div>
        </div>
      </div>

      {step === 1 && (
        <>
          {/* First Row - Fixed Pricing Cards (3 services) */}
          <div className="pricing-container">
            {services.slice(0, 3).map((service) => {
              const isPurchased = isServicePurchased(service._id);

              return (
                <div
                  key={service._id}
                  className={`pricing-card ${selectedService?._id === service._id ? 'selected' : ''} ${service.popular ? 'popular' : ''} ${isPurchased ? 'disabled' : ''}`}
                  onClick={() => !isPurchased && setSelectedService(service)}
                  data-service-id={service._id}
                >
                  {service.popular && (
                    <div className="popular-badge">
                      <FaStar /> Most Popular
                    </div>
                  )}

                  {isPurchased && (
                    <></>
                  )}

                  <h3>{service.name}</h3>
                  <div className="price">
                    ${service.price}
                    <span>/{service.frequency}</span>
                  </div>
                  <div className="service-details">
                    {service.details.map((detail, index) => (
                      <p key={index}><FaCheck className="feature-icon" /> {detail}</p>
                    ))}
                  </div>
                  <button
                    className="payment-button"
                    onClick={(e) => handleBuyNow(e, service)}
                    disabled={!user || isPurchased}
                  >
                    {!user ? 'Login to Purchase' :
                      isPurchased ? 'Already Purchased' : 'Buy Now'}
                  </button>
                </div>
              );
            })}
          </div>

          <br />
          <br />

          {/* Enhanced Slider Section */}
          <div className="slider-section">
            <div className="slider-wrapper">
              <div className="slider-container">
                <input
                  type="range"
                  className="custom-range-slider"
                  min="1"
                  max={maxDots}
                  step="1"
                  value={sliderValue}
                  onChange={handleSliderChange}
                />
                
                <div className="slider-track">
                  <div 
                    className="slider-track-progress" 
                    style={{ 
                      width: `${((sliderValue - 1) / (maxDots - 1)) * 100}%` 
                    }}
                  ></div>
                </div>
              </div>
              <div className="expense-range-text text-center">
                Up to ${(20000 + (sliderValue - 1) * 15000).toLocaleString()} in monthly expenses
              </div>
            </div>
          </div>

          {/* Second Row - Dynamic Pricing Cards (remaining services) */}
          <div className="pricing-container">
            {services.slice(3).map((service) => {
              const isPurchased = isServicePurchased(service._id);

              return (
                <div
                  key={service._id}
                  className={`pricing-card ${selectedService?._id === service._id ? 'selected' : ''} ${service.popular ? 'popular' : ''} ${isPurchased ? 'disabled' : ''}`}
                  onClick={() => !isPurchased && setSelectedService(service)}
                  data-service-id={service._id}
                >
                  {service.popular && (
                    <div className="popular-badge">
                      <FaStar /> Most Popular
                    </div>
                  )}

                  {isPurchased && (
                    <></>
                  )}

                  <h3>{service.name}</h3>
                  <div className="price">
                    ${service.price}
                    <span>/{service.frequency}</span>
                  </div>
                  <div className="service-details">
                    {service.details.map((detail, index) => (
                      <p key={index}><FaCheck className="feature-icon" /> {detail}</p>
                    ))}
                  </div>
                  <div className="pricing-card-footer">
                    <button
                      className="payment-button"
                      onClick={(e) => handleBuyNow(e, service)}
                      disabled={!user || isPurchased}
                    >
                      {!user ? 'Login to Purchase' :
                        isPurchased ? 'Already Purchased' : 'Buy Now'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}

      {step === 1.1 && (
        <div className="company-formation-container">
          <div className="company-formation-card">
            <div className="company-formation-grid">
              {/* Left Column - Tight Layout */}
              <div className="company-formation-left">
                {/* Company Type Selection - Tight */}
                <div className="company-type-selection-tight">
                  <h3 className="section-title-tight">Select Type of Company</h3>
                  <div className="company-type-options-horizontal">
                    {companyTypes.map((type) => (
                      <div
                        key={type}
                        className={`company-type-option-tight ${companyType === type ? 'selected' : ''}`}
                        onClick={() => handleCompanyTypeSelect(type)}
                      >
                        <div className="company-type-radio-tight">
                          {companyType === type && <div className="company-type-radio-selected-tight"></div>}
                        </div>
                        <h4 className="option-label-tight">{type}</h4>
                      </div>
                    ))}
                  </div>
                </div>

                {/* State Selection - Tight */}
                {companyType && (
                  <div className="state-selection-tight">
                    <h3 className="section-title-tight">Select State</h3>
                    <div className="state-options-grid-tight">
                      {usStates.map((state) => (
                        <div
                          key={state}
                          className={`state-option-tight ${selectedState === state ? 'selected' : ''}`}
                          onClick={() => handleStateSelect(state)}
                        >
                          <div className="state-radio-tight">
                            {selectedState === state && <div className="state-radio-selected-tight"></div>}
                          </div>
                          <h4 className="option-label-tight">{state}</h4>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* EIN Number - Tight */}
                {selectedState && (
                  <div className="ein-selection-tight">
                    <h3 className="section-title-tight">EIN Number</h3>
                    <p className="section-subtitle-tight">Do you have a Social Security Number (SSN)?</p>
                    <div className="ssn-options-horizontal-tight">
                      <button
                        className={`ssn-option-tight ${hasSSN === true ? 'selected' : ''}`}
                        onClick={() => handleSSNSelect(true)}
                        style={{border: '2px solid #ccc'}}
                      >
                        Yes ($55)
                      </button>
                      <button
                        className={`ssn-option-tight ${hasSSN === false ? 'selected' : ''}`}
                        onClick={() => handleSSNSelect(false)}
                        style={{border: '2px solid #ccc'}}
                      >
                        No ($210)
                      </button>
                    </div>

                  </div>
                )}

                {/* Registered Agent - Tight */}
                {hasSSN !== null && (
                  <div className="registered-agent-tight">
                    <div className="registered-agent-option-tight">
                      {/* <input
                        type="checkbox"
                        checked={registeredAgent}
                        onChange={handleRegisteredAgentChange}
                        className="checkbox-tight"
                      /> */}
                      <span className="agent-label-tight">1st Year Registered Agent included</span>
                      {/* {!registeredAgent && (
                        <span className="registered-agent-fee-tight">+$125/yr</span>
                      )} */}
                    </div>
                  </div>
                )}

              </div>

              {/* Right Column - Fees Breakdown */}
              {selectedState && (
                <div className="company-formation-right-tight">
                  {/* Promo Code Section - Tight */}
                  <div className="promo-code-section-tight">
                    <h3 className="section-title-tight">Promo Code (Optional)</h3>
                    <div className="promo-code-input-group-tight">
                      <input
                        type="text"
                        placeholder="Enter promo code"
                        value={promoCode}
                        onChange={(e) => setPromoCode(e.target.value.toUpperCase())}
                        className="promo-code-input-tight"
                        disabled={promoCodeLoading}
                      />
                      <button
                        onClick={validatePromoCode}
                        disabled={promoCodeLoading || !promoCode.trim()}
                        className="promo-code-validate-btn-tight"
                      >
                        {promoCodeLoading ? 'Validating...' : 'Apply'}
                      </button>
                    </div>
                    {promoCodeError && (
                      <p className="promo-code-error-tight">{promoCodeError}</p>
                    )}
                    {promoCodeDetails && (
                      <div className="promo-code-success-tight">
                        <p className="promo-code-success-text-tight">
                          ✓ {promoCodeDetails.discountPercentage}% off applied to {promoCodeDetails.applicableFee}
                        </p>
                        <button
                          onClick={clearPromoCode}
                          className="promo-code-clear-btn-tight"
                        >
                          Remove
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="fees-breakdown-tight">
                    <h3 className="section-title-tight">Fees Breakdown</h3>
                    <div className="fees-table-tight">
                      <div className="fee-row-tight">
                        <span>Our Fee:</span>
                        <span>
                          {promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' ? (
                            <>
                              <span style={{ textDecoration: 'line-through', color: '#999' }}>$300</span>
                              <span style={{ marginLeft: '8px', color: '#28a745' }}>
                                ${(300 - (300 * promoCodeDetails.discountPercentage / 100)).toFixed(2)}
                              </span>
                            </>
                          ) : (
                            '$300'
                          )}
                        </span>
                      </div>
                      {promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' && (
                        <div className="fee-row-tight promo-discount-tight">
                          <span>Promo Discount:</span>
                          <span style={{ color: '#28a745' }}>
                            -${(300 * promoCodeDetails.discountPercentage / 100).toFixed(2)}
                          </span>
                        </div>
                      )}
                      <div className="fee-row-tight">
                        <span>State Fee:</span>
                        <span>${stateFees[companyType][selectedState]}</span>
                      </div>
                      {hasSSN !== null && (
                        <div className="fee-row-tight">
                          <span>EIN Service:</span>
                          <span>${hasSSN ? '55' : '210'}</span>
                        </div>
                      )}

                      {!registeredAgent && (
                        <div className="fee-row-tight">
                          <span>Registered Agent:</span>
                          <span>$125</span>
                        </div>
                      )}
                      <div className="fee-row-tight total-tight">
                        <span>Total:</span>
                        <span>
                          ${(300 - (promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' ? (300 * promoCodeDetails.discountPercentage / 100) : 0)) +
                            stateFees[companyType][selectedState] +
                            (hasSSN !== null ? (hasSSN ? 55 : 210) : 0) +
                            (!registeredAgent ? 125 : 0)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons - Tight */}
                  <div className="company-formation-actions-tight">
                    <button
                      className="back-button-tight"
                      onClick={() => setStep(1)}
                    >
                      Back
                    </button>
                    <button
                      className="proceed-button-tight"
                      onClick={() => setStep(2)}
                      disabled={!companyType || !selectedState || hasSSN === null}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {step === 1.25 && (
        <div className="hours-selection-container">
          <div className="hours-selection-card">

            <div className="hours-control-section">
              <div className="hours-input-group">
                <label htmlFor="hours-input" className="hours-input-label">
                  Number of Hours
                </label>
                <div className="hours-input-wrapper">
                  <button
                    className="hours-adjust-btn"
                    onClick={() => setHours(Math.max(1, hours - 1))}
                    aria-label="Decrease hours"
                  >
                    -
                  </button>
                  <input
                    id="hours-input"
                    type="number"
                    min="1"
                    max="100"
                    value={hours}
                    onChange={handleHoursChange}
                    className="hours-input"
                  />
                  <button
                    className="hours-adjust-btn"
                    onClick={() => setHours(Math.min(100, hours + 1))}
                    aria-label="Increase hours"
                  >
                    +
                  </button>
                </div>
              </div>

              <div className="hours-summary-card">
                <div className="summary-row">
                  <span>Hourly Rate:</span>
                  <span>${selectedService.price}</span>
                </div>
                <div className="summary-row">
                  <span>Hours Selected:</span>
                  <span>{hours}</span>
                </div>
                <div className="summary-divider"></div>
                <div className="summary-row total">
                  <span>Total Amount:</span>
                  <span>${(selectedService.price * hours).toFixed(2)}</span>
                </div>
              </div>
            </div>

            <div className="hours-action-buttons">
              <button
                className="hours-back-btn"
                onClick={() => setStep(1)}
              >
                Back to Plans
              </button>
              <button
                className="hours-continue-btn"
                onClick={() => setStep(2)}
              >
                Continue to Checkout
              </button>
            </div>
          </div>
        </div>
      )}

      {step === 1.5 && (
        <div className="tax-details-container">
          {/* Mobile-only Price Summary (shown only on small screens) */}
          <div className="mobile-tax-summary">
            <h3>Price Summary</h3>
            <div className="price-breakdown">
              <div className="price-row">
                <span className="price-label">Base Price:</span>
                <span className="price-value">${selectedService.price}</span>
              </div>
              {taxType && taxTypeDetails[taxType].questions.map((question) => (
                taxQuestions[question.id] && (
                  <div key={question.id} className="price-row">
                    <span className="price-label">{question.text}:</span>
                    <span className="price-value">+${question.price}</span>
                  </div>
                )
              ))}
              <div className="price-total">
                <span className="price-label">Total:</span>
                <span className="price-value">${selectedService.price + additionalPrice}</span>
              </div>
            </div>
          </div>

          <div className="tax-content-container">
            {/* Left Column */}
            <div className="tax-left-column">
              {/* Tax Type Selection */}
              <div className="tax-type-selection">
                <div className="tax-type-options">
                  <div
                    className={`tax-type-option ${taxType === 'business' ? 'selected' : ''}`}
                    onClick={() => handleTaxTypeSelect('business')}
                  >
                    <div className="tax-type-radio">
                      {taxType === 'business' && <div className="tax-type-radio-selected"></div>}
                    </div>
                    <h4>Business Tax Return Filing (Forms 1120, 1120S, 1065)</h4>
                  </div>
                  <div
                    className={`tax-type-option ${taxType === 'personal' ? 'selected' : ''}`}
                    onClick={() => handleTaxTypeSelect('personal')}
                  >
                    <div className="tax-type-radio">
                      {taxType === 'personal' && <div className="tax-type-radio-selected"></div>}
                    </div>
                    <h4>Personal Tax Return Filing (Form 1040)</h4>
                  </div>
                </div>
              </div>

              {/* Additional Questions */}
              {taxType && (
                <div className="tax-questions-section">
                  <h3>Additional Questions</h3>
                  <div className="questions-table">
                    {taxTypeDetails[taxType].questions.map((question) => (
                      <div key={question.id} className="question-row">
                        <div className="question-text">{question.text}</div>
                        <div className="question-options">
                          <button
                            className={`option-btn ${taxQuestions[question.id] === true ? 'selected' : ''}`}
                            onClick={() => handleTaxQuestionChange(question.id, true)}
                          >
                            Yes
                          </button>
                          <button
                            className={`option-btn ${taxQuestions[question.id] === false ? 'selected' : ''}`}
                            onClick={() => handleTaxQuestionChange(question.id, false)}
                          >
                            No
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Right Column - Price Summary and Actions (hidden on mobile) */}
            {taxType && (
              <div className="tax-summary-column">
                <div className="tax-summary-section">
                  <h3>Price Summary</h3>
                  <div className="price-breakdown">
                    <div className="price-row">
                      <span className="price-label">Base Price:</span>
                      <span className="price-value">${selectedService.price}</span>
                    </div>
                    {taxTypeDetails[taxType].questions.map((question) => (
                      taxQuestions[question.id] && (
                        <div key={question.id} className="price-row">
                          <span className="price-label">{question.text}:</span>
                          <span className="price-value">+${question.price}</span>
                        </div>
                      )
                    ))}
                    <div className="price-total">
                      <span className="price-label">Total:</span>
                      <span className="price-value">${selectedService.price + additionalPrice}</span>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="tax-details-actions">
                  <button className="back-button" onClick={() => setStep(1)}>Back</button>
                  <button
                    className="proceed-button"
                    onClick={() => setStep(2)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Mobile-only Action Buttons (shown only on small screens) */}
          <div className="mobile-tax-actions">
            <button className="back-button" onClick={() => setStep(1)}>Back</button>
            <button
              className="proceed-button"
              onClick={() => setStep(2)}
              disabled={!taxType}
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {step === 2 && (
        <div className="location-selection-container">
          <div className="location-selection-card">
            <div className="location-options">
              <div
                className={`location-option ${location === 'international' ? 'selected' : ''}`}
                onClick={() => handleLocationSelect('international')}
              >
                <div className="option-radio">
                  {location === 'international' && <div className="option-radio-selected"></div>}
                </div>
                <div className="option-content">
                  <h3>Outside India (USD)</h3>
                </div>
              </div>
              <div
                className={`location-option ${location === 'india' ? 'selected' : ''}`}
                onClick={() => handleLocationSelect('india')}
              >
                <div className="option-radio">
                  {location === 'india' && <div className="option-radio-selected"></div>}
                </div>
                <div className="option-content">
                  <h3>India (INR, GST Applicable)</h3>
                  <p className="exchange-rate">Current rate: 1 USD = ₹{exchangeRate.toFixed(2)}</p>

                  {location === 'india' && (
                    <div className="fruit-selection">
                      <label htmlFor="fruit-select">Select a State:</label>
                      <select
                        id="fruit-select"
                        value={selectedFruit}
                        onChange={(e) => setSelectedFruit(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <option value="">-- Select a State --</option>
                        {fruits.map((fruit) => (
                          <option key={fruit} value={fruit}>{fruit}</option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="location-actions">
              <button className="back-button" onClick={() => {
                if (selectedService._id === 'service_1') {
                  setStep(1.1);
                } else if (selectedService._id === 'service_2') {
                  setStep(1.5);
                } else if (selectedService._id === 'service_3') {
                  setStep(1.25);
                } else {
                  setStep(1);
                }
              }}>Back</button>
              {location && (
                <button
                  className="proceed-button"
                  onClick={handleProceedWithFruit}
                  disabled={location === 'india' && !selectedFruit}
                >
                  Proceed
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="checkout-container">
          <div className="checkout-summary">
            <h2>Order Details</h2>
            <div className="summary-item"><span>Service:</span><span>{selectedService.name}</span></div>

            {selectedService._id === 'service_1' && (
              <>
                <div className="summary-item">
                  <span>Company Type:</span>
                  <span>{companyType}</span>
                </div>
                <div className="summary-item">
                  <span>State:</span>
                  <span>{selectedState}</span>
                </div>
                <div className="summary-item">
                  <span>Our Fee:</span>
                  <span>
                    {promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' ? (
                      location === 'india' ? (
                        <>
                          <span style={{ textDecoration: 'line-through', color: '#999' }}>
                            ₹{(300 * exchangeRate).toFixed(2)}
                          </span>
                          <span style={{ marginLeft: '8px', color: '#28a745' }}>
                            ₹{((300 - (300 * promoCodeDetails.discountPercentage / 100)) * exchangeRate).toFixed(2)}
                          </span>
                        </>
                      ) : (
                        <>
                          <span style={{ textDecoration: 'line-through', color: '#999' }}>$300</span>
                          <span style={{ marginLeft: '8px', color: '#28a745' }}>
                            ${(300 - (300 * promoCodeDetails.discountPercentage / 100)).toFixed(2)}
                          </span>
                        </>
                      )
                    ) : (
                      location === 'india' ? '₹' + (300 * exchangeRate).toFixed(2) : '$300'
                    )}
                  </span>
                </div>
                {promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' && (
                  <div className="summary-item">
                    <span>Promo Discount ({promoCodeDetails.code}):</span>
                    <span style={{ color: '#28a745' }}>
                      {location === 'india' ? 
                        `-₹${((300 * promoCodeDetails.discountPercentage / 100) * exchangeRate).toFixed(2)}` : 
                        `-$${(300 * promoCodeDetails.discountPercentage / 100).toFixed(2)}`}
                    </span>
                  </div>
                )}
                <div className="summary-item">
                  <span>State Fee:</span>
                  <span>
                    {location === 'india' ?
                      '₹' + (stateFees[companyType][selectedState] * exchangeRate).toFixed(2) :
                      '$' + stateFees[companyType][selectedState]}
                  </span>
                </div>
                <div className="summary-item">
                  <span>EIN Service:</span>
                  <span>
                    {hasSSN ?
                      (location === 'india' ? '₹' + (55 * exchangeRate).toFixed(2) : '$55') :
                      (location === 'india' ? '₹' + (210 * exchangeRate).toFixed(2) : '$210')}
                  </span>
                </div>
                {!registeredAgent && (
                  <div className="summary-item">
                    <span>Registered Agent:</span>
                    <span>{location === 'india' ? '₹' + (125 * exchangeRate).toFixed(2) : '$125'}</span>
                  </div>
                )}
              </>
            )}

            {selectedService._id === 'service_2' && taxType && (
              <div className="summary-item">
                <span>Tax Type:</span>
                <span>{taxType === 'business' ? 'Business Tax Filing' : 'Personal Tax Filing'}</span>
              </div>
            )}

            {selectedService._id === 'service_3' && (
              <div className="summary-item">
                <span>Hours Selected:</span>
                <span>{hours} hours</span>
              </div>
            )}

            <div className="summary-item">
              <span>Billing Frequency:</span>
              <span>{selectedService.frequency}</span>
            </div>
            <div className="summary-item">
              <span>Location:</span>
              <span>
                {location === 'india' ?
                  `India${selectedFruit ? ` (${selectedFruit})` : ''}` :
                  'Outside India'}
              </span>
            </div>

            {selectedService._id === 'service_2' && taxType && (
              <>
                <div className="summary-item">
                  <span>Base Price:</span>
                  <span>{location === 'india' ? '₹' + (selectedService.price * exchangeRate).toFixed(2) : '$' + selectedService.price}</span>
                </div>
                {taxTypeDetails[taxType].questions.map((question) => (
                  taxQuestions[question.id] && (
                    <div key={question.id} className="summary-item">
                      <span>{question.text}:</span>
                      <span>{location === 'india' ? '₹' + (question.price * exchangeRate).toFixed(2) : '+$' + question.price}</span>
                    </div>
                  )
                ))}
              </>
            )}

            {selectedService._id === 'service_3' && (
              <>
                <div className="summary-item">
                  <span>Hourly Rate:</span>
                  <span>{location === 'india' ? '₹' + (selectedService.price * exchangeRate).toFixed(2) : '$' + selectedService.price}</span>
                </div>
                <div className="summary-item">
                  <span>Hours Selected:</span>
                  <span>{hours}</span>
                </div>
              </>
            )}

            {location === 'india' && (
              <>
                <div className="summary-item">
                  <span>
                    GST (18%)
                    <span
                      className="gst-breakup-toggle"
                      onClick={() => setShowTaxBreakup(!showTaxBreakup)}
                      style={{ cursor: 'pointer', color: '#007BFF', marginLeft: '5px' }}
                      title="Click to view tax breakdown"
                    >
                      *
                    </span>
                  </span>
                  <span>₹{getConvertedPrice().gst}</span>
                </div>

                {showTaxBreakup && (
                  <div className="gst-breakup-details">
                    {selectedFruit === 'Gujarat' ? (
                      <p className="tax-info">CGST: 9% + SGST: 9%</p>
                    ) : (
                      <p className="tax-info">IGST: 18%</p>
                    )}
                  </div>
                )}

                <div className="summary-item gstin-item">
                  <span>GSTIN:</span>
                  <span>
                    {gstin ? gstin : (
                      <button
                        className="add-gstin-button"
                        onClick={() => setShowGstinModal(true)}
                      >
                        Add GSTIN Number
                      </button>
                    )}
                  </span>
                </div>
              </>
            )}
            <div className="summary-item total">
              <span>Total:</span>
              <span>
                {location === 'india' ?
                  `₹${getConvertedPrice().total}` :
                  selectedService._id === 'service_1' ?
                    `$${((300 - (promoCodeDetails && promoCodeDetails.applicableFee === 'Our Fee' ? (300 * promoCodeDetails.discountPercentage / 100) : 0)) + stateFees[companyType][selectedState] + (hasSSN ? 55 : 210) + (!registeredAgent ? 125 : 0)).toFixed(2)}` :
                    selectedService._id === 'service_3' ?
                      `$${(selectedService.price * hours).toFixed(2)}` :
                      `$${(selectedService.price + additionalPrice).toFixed(2)}`
                }
              </span>
            </div>
          </div>

          <div className="checkout-form">
            <h3>Details for Invoice</h3>

            <div className="form-group">
              <input
                type="text"
                placeholder="Full Name *"
                value={fullName}
                onChange={(e) => {
                  setFullName(e.target.value);
                  if (e.target.value) {
                    setFormErrors(prev => ({ ...prev, fullName: '' }));
                  }
                }}
                className={formErrors.fullName ? 'input-error' : ''}
                required
              />
              {formErrors.fullName && (
                <div className="error-message">
                  <FaExclamationCircle /> {formErrors.fullName}
                </div>
              )}
            </div>

            <div className="form-group">
              <input
                type="text"
                placeholder="Full Address *"
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                  if (e.target.value) {
                    setFormErrors(prev => ({ ...prev, address: '' }));
                  }
                }}
                className={formErrors.address ? 'input-error' : ''}
                required
              />
              {formErrors.address && (
                <div className="error-message">
                  <FaExclamationCircle /> {formErrors.address}
                </div>
              )}
            </div>

            {location === 'india' && selectedFruit && (
              <div className="selected-fruit-display">
                <p><strong>State:</strong> {selectedFruit}</p>
              </div>
            )}

            {location === 'india' && (
              <div className="selected-fruit-display">
                <p><strong>Country:</strong> India</p>
              </div>
            )}

            {location === 'international' && (
              <div className="country-selection form-group">
                <label htmlFor="country-select">Select Country: *</label>
                <select
                  id="country-select"
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    if (e.target.value) {
                      setFormErrors(prev => ({ ...prev, country: '' }));
                    }
                  }}
                  className={formErrors.country ? 'input-error' : ''}
                  required
                >
                  <option value="">-- Select a Country --</option>
                  {allCountries.map((countryName) => (
                    <option key={countryName} value={countryName}>
                      {countryName}
                    </option>
                  ))}
                </select>
                {formErrors.country && (
                  <div className="error-message">
                    <FaExclamationCircle /> {formErrors.country}
                  </div>
                )}
              </div>
            )}

            {/* Action Buttons - Now positioned below Details for Invoice */}
            <div className="payment-actions">
              <button className="back-button" onClick={() => setStep(2)}>Back</button>
              <RazorpayPayment
                service={selectedService}
                user={user}
                location={location}
                country={country}
                fullName={fullName}
                address={address}
                exchangeRate={exchangeRate}
                gstin={gstin}
                selectedFruit={selectedFruit}
                taxType={taxType}
                taxQuestions={taxQuestions}
                additionalPrice={additionalPrice}
                hours={selectedService?._id === 'service_3' ? hours : undefined}
                companyType={selectedService?._id === 'service_1' ? companyType : undefined}
                selectedState={selectedService?._id === 'service_1' ? selectedState : undefined}
                hasSSN={selectedService?._id === 'service_1' ? hasSSN : undefined}
                registeredAgent={selectedService?._id === 'service_1' ? registeredAgent : undefined}
                promoCodeDetails={promoCodeDetails}
                onValidationError={(errors) => {
                  setFormErrors(errors);
                  toast.error('Please fill in all required fields');
                }}
                renderButton={(handlePayment) => (
                  <button
                    className="proceed-button"
                    onClick={() => {
                      // Clear previous errors
                      setFormErrors({});
                      
                      // Validate required fields
                      const errors = {};
                      
                      if (!fullName.trim()) {
                        errors.fullName = 'Full Name is required';
                      }
                      
                      if (!address.trim()) {
                        errors.address = 'Address is required';
                      }
                      
                      if (location === 'international' && !country) {
                        errors.country = 'Country is required';
                      }
                      
                      if (Object.keys(errors).length > 0) {
                        setFormErrors(errors);
                        toast.error('Please fill in all required fields');
                        return;
                      }
                      
                      // If validation passes, trigger payment
                      handlePayment();
                    }}
                  >
                    Proceed to Pay {location === 'india' ? 
                      `₹${getConvertedPrice().total}` : 
                      `$${parseFloat(getConvertedPrice().total).toFixed(2)}`
                    }
                  </button>
                )}
              />
              
              {/* Hidden RazorpayPayment component */}
              <div style={{ display: 'none' }}>
                <RazorpayPayment
                  id="razorpay-payment"
                  service={selectedService}
                  user={user}
                  location={location}
                  country={country}
                  fullName={fullName}
                  address={address}
                  exchangeRate={exchangeRate}
                  gstin={gstin}
                  selectedFruit={selectedFruit}
                  taxType={taxType}
                  taxQuestions={taxQuestions}
                  additionalPrice={additionalPrice}
                  hours={selectedService._id === 'service_3' ? hours : undefined}
                  companyType={selectedService._id === 'service_1' ? companyType : undefined}
                  selectedState={selectedService._id === 'service_1' ? selectedState : undefined}
                  hasSSN={selectedService._id === 'service_1' ? hasSSN : undefined}
                  registeredAgent={selectedService._id === 'service_1' ? registeredAgent : undefined}
                  promoCodeDetails={promoCodeDetails}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Pricing;